import { NOTIFICATIONS_COPY as copy } from "@/screens/app/notifications/copy"

export interface SubscriberLike {
	userId: string
	source: string
	user?: { name?: string | null; email?: string | null } | null
}

function displayName(subscriber: SubscriberLike, selfId: string) {
	if (subscriber.userId === selfId) return copy.subscribe.you
	return subscriber.user?.name ?? subscriber.user?.email ?? ""
}

/** The caller first, then everyone else in the order the query returned them. */
export function orderSubscribers<T extends SubscriberLike>(
	subscribers: readonly T[],
	selfId: string,
): T[] {
	const self = subscribers.filter((s) => s.userId === selfId)
	const others = subscribers.filter((s) => s.userId !== selfId)
	return [...self, ...others]
}

/** "You, Raphael and Mira get updates"; past three names the rest become a count. */
export function subscribersSentence(
	subscribers: readonly SubscriberLike[],
	selfId: string,
): string {
	const names = orderSubscribers(subscribers, selfId)
		.map((s) => displayName(s, selfId))
		.filter(Boolean)
	if (names.length === 0) return copy.subscribe.nobody
	if (names.length === 1) {
		return names[0] === copy.subscribe.you
			? `${names[0]} get updates`
			: `${names[0]} gets updates`
	}
	const shown =
		names.length > 3
			? [...names.slice(0, 2), copy.subscribe.others(names.length - 2)]
			: names
	const last = shown[shown.length - 1]
	return `${shown.slice(0, -1).join(", ")} and ${last} get updates`
}

export function subscriberSourceLabel(source: string) {
	return copy.subscribe.sources[source] ?? copy.subscribe.sources.manual
}
